// Simple helper to avoid pointless warning repetition
const _alreadyWarned = new Set();
export function warnOnce(txt) {
  if (!_alreadyWarned.has(txt)) {
    console.warn(txt);
    _alreadyWarned.add(txt);
  }
}